/*
 * @Description:
 * @Author: Ian
 * @Date: 2023-10-19 16:59:15
 * @LastEditTime: 2023-10-20 13:38:38
 * @LastEditors: Ian
 */
import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";
import { TbBrandDisney } from "react-icons/tb";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Christian Angon </span>
            from <span className="purple"> Cavite, Philippines.</span>
            <br /> I am a professional{" "}
            <span className="purple">front end developer </span>with{" "}
            <span className="purple">4</span> years of experienced
            <br />
            Additionally, I am currently employed as a front end developer here
            in Manila, Philippines.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Watching Movies & Tv Series
            </li>
            <li className="about-activity">
              <ImPointRight /> Playing Basketball
            </li>
            <li className="about-activity">
              <ImPointRight /> Reading Comic Books
            </li>
          </ul>
          <br />
          <p style={{ color: "rgb(155 126 172)" }}>
            "We keep moving forward, opening up new doors and doing new things,
            because we're curious…and curiosity keeps leading us down new paths"{" "}
          </p>
          <footer className="blockquote-footer">
            <TbBrandDisney />
            Meet the Robinsons
          </footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
